export default __webpack_public_path__ + "images/45ac928bd535f5aee8ee047e517303c3.jpg";